module.exports = __webpack_public_path__ + "img/home_58.77beb1d1.png";